import { render, staticRenderFns } from "./SubjectProgress.vue?vue&type=template&id=5d3b31b3&scoped=true&lang=pug&"
import script from "./SubjectProgress.vue?vue&type=script&lang=ts&"
export * from "./SubjectProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3b31b3",
  null
  
)

export default component.exports